import { createSlice } from "@reduxjs/toolkit";


export const formulesElevesSlice = createSlice({
    name: 'formulesEleves',
    initialState:{},
    reducers: { // 
       
        setFormulesEleves: (currentState, action) => {
           
            let newList = currentState.filter((ligne)=>ligne.id_eleve!==action.payload.id_eleve);
            newList.push(action.payload);
            return newList;

        },
        resetFormulesEleves: (currentState, action) => {
           
            return [];

        },
       
    }
});

